import React from "react";
import DomoFunnel from "../../../../components/charts/domoFunnel/domoFunnel";
import { shallowEqual, useSelector } from "react-redux";

const IntroConversionChart = () => {
  const { filters, offersDataNormalized } = useSelector((state) => {
    const { filters, offersDataNormalized } = state.introConversion;
    return { filters, offersDataNormalized };
  }, shallowEqual);
  return <DomoFunnel chartWidth={950} filters={filters} dataArray={offersDataNormalized} />;
};

export default IntroConversionChart;
